export default "__VITE_ASSET__C2HPLnb7__"